import { useEffect, useState } from "react";
import BookedTourCard from "./BookedTourCard";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import CurrentDate from "./CurrentDate";

function PersonalTourCards({
  bookingsByDate, // Now representing transformedObject
  onToggleConfirmationCard,
  isConfirmationCardVisible,
  setIsChangeModalOpen,
  setIsCancelModalOpen,
  processedVenues,
}) {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [tourNameArr, setTourNameArr] = useState(null);
  const [tourCategoriesArr, setTourCategoriesArr] = useState(null);
  const navigate = useNavigate();
  const {
    details: detailsAfterBooking,
    loading: loadingDetailsAfterBooking,
    error: errorDetailsAfterBooking,
  } = useSelector((state) => state.toursDetailsAfterBooking);

  const {
    categories: categoriesAfterBooking,
    loading: loadingCategoriesAfterBooking,
    error: errorCategoriesAfterBooking,
  } = useSelector((state) => state.categoriesAfterBooking);

  useEffect(() => {
    if (categoriesAfterBooking?.data && detailsAfterBooking?.data) {
      setTourCategoriesArr(categoriesAfterBooking.data);
      setTourNameArr(detailsAfterBooking.data);

      // Your logic here
    }
  }, [categoriesAfterBooking, detailsAfterBooking]);
  const handleButtonClick = (index) => {
    setSelectedIndex(index);
    onToggleConfirmationCard();
  };

  return (
    <div className="leap-pt-40">
      {Object.entries(bookingsByDate)?.map(([date, dataObject], index) => (
        <CurrentDate
          date={date}
          bookingsByDate={bookingsByDate}
          dataObject={dataObject}
          index={index}
          isConfirmationCardVisible={isConfirmationCardVisible}
          selectedIndex={selectedIndex}
          handleButtonClick={handleButtonClick}
          tourNameArr={tourNameArr}
          tourCategoriesArr={tourCategoriesArr}
          setIsChangeModalOpen={setIsChangeModalOpen}
          setIsCancelModalOpen={setIsCancelModalOpen}
          processedVenues={processedVenues}
        />
      ))}
    </div>
  );
}

export default PersonalTourCards;
